// extracted by mini-css-extract-plugin
export default {"heading":"Business_heading__fvb2K","wrapper":"Business_wrapper__84SE0"};